import React, { useState, useEffect, useRef } from 'react';
import firestore from './firebaseConfig';


const servers = {
  iceServers: [
    {
      urls: ['stun:stun1.l.google.com:19302', 'stun:stun2.l.google.com:19302'],
    },
  ],
  iceCandidatePoolSize: 10,
};

const WebRTCComponent = () => {
  const [localStream, setLocalStream] = useState(null);
  const [remoteStream, setRemoteStream] = useState(null);
  const [callId, setCallId] = useState('');
  const pc = useRef(new RTCPeerConnection(servers));
  const webcamVideo = useRef();
  const remoteVideo = useRef();
  //useEffect(()=>() => {pc.current.close()},[pc.current]);
  useEffect(() => {
    const pcCurrent = pc.current;

    pcCurrent.ontrack = (event) => {
      event.streams[0].getTracks().forEach((track) => {
        if (remoteStream) {
          remoteStream.addTrack(track);
        }
      });
    };

    //return () => pcCurrent.close();
  }, [remoteStream]);

  const startWebcam = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ video: document.getElementById("videoCheckBox").checked, audio: {autoGainControl: false,
    channelCount: 2,
    echoCancellation: false,
    latency: 0,
    noiseSuppression: false,
    sampleRate: 48000,
    sampleSize: 16,
    volume: 1.0} });
    setLocalStream(stream);
    webcamVideo.current.srcObject = stream;

    const callback = () => {
        
        stream.getTracks().forEach((track) => {
        pc.current.addTrack(track, stream);
        });

        const newRemoteStream = new MediaStream();
        setRemoteStream(newRemoteStream);
        remoteVideo.current.srcObject = newRemoteStream;
        pc.current.onsignalingstatechange = null;
    };
    pc.current.onsignalingstatechange = callback;
    if (pc.current.signalingState !== 'closed') {
        callback();
    }
  };

  const createOffer = async () => {
    const callDoc = firestore.collection('calls').doc();
    const offerCandidates = callDoc.collection('offerCandidates');
    const answerCandidates = callDoc.collection('answerCandidates');

    setCallId(callDoc.id);

    pc.current.onicecandidate = (event) => {
      event.candidate && offerCandidates.add(event.candidate.toJSON());
    };

    const offerDescription = await pc.current.createOffer();
    await pc.current.setLocalDescription(offerDescription);

    const offer = {
      sdp: offerDescription.sdp,
      type: offerDescription.type,
    };

    await callDoc.set({ offer });

    callDoc.onSnapshot((snapshot) => {
      const data = snapshot.data();
      if (!pc.current.currentRemoteDescription && data?.answer) {
        const answerDescription = new RTCSessionDescription(data.answer);
        pc.current.setRemoteDescription(answerDescription);
      }
    });

    answerCandidates.onSnapshot((snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type === 'added') {
          const candidate = new RTCIceCandidate(change.doc.data());
          pc.current.addIceCandidate(candidate);
        }
      });
    });
  };

  const answerCall = async () => {
    const callDoc = firestore.collection('calls').doc(callId);
    const answerCandidates = callDoc.collection('answerCandidates');
    const offerCandidates = callDoc.collection('offerCandidates');

    pc.current.onicecandidate = (event) => {
      event.candidate && answerCandidates.add(event.candidate.toJSON());
    };

    const callData = (await callDoc.get()).data();
    const offerDescription = callData.offer;
    await pc.current.setRemoteDescription(new RTCSessionDescription(offerDescription));

    const answerDescription = await pc.current.createAnswer();
    await pc.current.setLocalDescription(answerDescription);

    const answer = {
      type: answerDescription.type,
      sdp: answerDescription.sdp,
    };

    await callDoc.update({ answer });

    offerCandidates.onSnapshot((snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type === 'added') {
          const candidate = new RTCIceCandidate(change.doc.data());
          pc.current.addIceCandidate(candidate);
        }
      });
    });
  };

  return (
    <div>
      <h2>Start audio/video streaming First</h2>
      <div className="videos">
        <video ref={webcamVideo} autoPlay muted playsInline controls style={{ width: '240px', height: '180px' }}></video>
        <video ref={remoteVideo} autoPlay playsInline controls style={{ width: '240px', height: '180px' }}></video>
      </div>
      <label><input type='checkbox' id='videoCheckBox'></input> video streaming</label>
      <button onClick={startWebcam}>Start audio/video streaming</button>
      <div>
        <button onClick={createOffer}>Create Call (offer)</button>
        <input value={callId} onChange={(e) => setCallId(e.target.value)} placeholder="Enter Call ID" />
        <button onClick={answerCall}>Answer</button>
      </div>
    </div>
  );
};

export default WebRTCComponent;
